const map = {
	"./DEVELOP.png": 3855,
	"./GUIDE.png": 84288,
	"./SOFTWARE.png": 19725,
	"./arrow-blue.png": 38114,
	"./arrow-white.png": 15203,
	"./close.png": 55176,
	"./folder.png": 10422,
	"./icon-1.png": 29311,
	"./icon-2.png": 44036,
	"./icon-3.png": 7277,
	"./icon-4.png": 77298,
	"./overview-icon-1.png": 29711,
	"./overview-icon-2.png": 55220,
	"./quick-start-btn.png": 62697,
	"./编组@2x.png": 50696
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70926;